import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import { useSnackbar, SnackbarContent } from 'notistack'
import { Text } from 'shared/ui'
import useStyles from './styles'

const Notification = forwardRef((props, ref) => {
  /** props destructure */
  const { notificationKey, msg, body, data } = props

  /** hooks */
  const classes = useStyles()
  const { closeSnackbar } = useSnackbar()

  /** generate href */
  let urlRedirect = undefined
  if (data?.conversation) {
    urlRedirect = `/conversations/${data.conversation.groups[0]}/view/${data.conversation.uid}`
  }

  /** onClose function */
  const onClose = () => closeSnackbar(notificationKey)

  /** get sender name */
  const getSenderName = () => {
    const sender = data?.sender?.contact || data?.sender?.agent
    if (sender) {
      let name = sender?.first_name || ''
      if (sender?.last_name)
        name += " " + sender?.last_name || ''
      if (!name || name.length <= 0)
        name = data?.sender?.address || `Contact ${sender?.uid % 9999}`
      return name
    } else return "Unknown"
  }

  /** render */
  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <Link to={urlRedirect} onClick={onClose} className={classes.notificationCard}>
        <Text style={{ fontWeight: 700 }}>
          {msg}
        </Text>
        <Text
          variant="body2"
          color="textSecondary"
          className={classes.notificationCardBody}
        >
          {body ||
            <>
              {getSenderName()}: {data?.body}
            </>
          }
        </Text>
      </Link>
    </SnackbarContent>
  )
})

export default Notification